export default function (cli) {
  return {
    daily (date, shop) {
      const params = {
        date,
        shop,
      }
      return cli.get(`${cli.adminApiEndpoint}analytics/daily/`).query(params)
    },
    dailyList (year, month, shop, recalculate) {
      const params = {
        shop,
      }
      if (recalculate) {
        params.recalculate = true
      }
      return cli.get(`${cli.adminApiEndpoint}analytics/daily/${year}/${month}/`).query(params)
    },
    customerStatus (year, month, shop, recalculate) {
      const params = {
        shop,
      }
      if (recalculate) {
        params.recalculate = true
      }
      return cli.get(`${cli.adminApiEndpoint}analytics/customer-status/${year}/${month}/`).query(params)
    },
    nextVisitForMonth (year, month, shop, recalculate) {
      const params = {
        shop,
      }
      if (recalculate) {
        params.recalculate = true
      }
      return cli.get(`${cli.adminApiEndpoint}analytics/next-visits/${year}/${month}/`).query(params)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/analytics.js